import { Anchor, Breadcrumbs, Group, SegmentedControl, Text, Title } from '@mantine/core';
import { useState } from 'react';
import { useParams } from 'react-router';
import AiDraftDecisions from '../../components/AiDrafts/AiDraftDecisions';
import AiDraftsList from '../../components/AiDrafts/AiDraftsList';
import Metadata from '../../components/Metadata';
import { Page } from '../../constants/pageTitles';

const CampaignProposalsPage = () => {
  const { accountId, domainId } = useParams();
  const [view, setView] = useState('pending');

  return (
    <>
      <Metadata title={`${Page.campaigns} | ${Page.campaignProposals}`} />
      <Breadcrumbs mb="md">
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Text>{Page.campaignProposals}</Text>
      </Breadcrumbs>
      <Group justify="space-between" mb="md">
        <Title order={3}>{Page.campaignProposals}</Title>
        <SegmentedControl
          value={view}
          onChange={setView}
          data={[
            { value: 'pending', label: 'Pending' },
            { value: 'decided', label: 'Decided' },
          ]}
        />
      </Group>
      {view === 'pending' ? (
        <AiDraftsList
          type="simple"
          emptyText="No drafts to review. When an AI assistant connected to this store prepares a campaign, it appears here for review."
        />
      ) : (
        <AiDraftDecisions type="simple" />
      )}
    </>
  );
};

export default CampaignProposalsPage;
